import api from '@/api/axios'
import { createCatalogApi } from '@/features/catalog/shared/catalogApi.mjs'

export default createCatalogApi(api)
